<template>
  <div class="pck-cont">
    <van-overlay :show="pickingVisible">
      <div class="wrapper" @click.stop>
        <div class="block">
          <p class="title">打印拣货单</p>
          <div class="pck-div">
            <p>总共可打印订单拣货单  ：<span>{{rform.enablePrintCount}}</span>个</p>
            <p>已备注订单或到付订单暂不能批量操作打印：<span>{{rform.disablePringCount}}</span>个</p>
            <p class="tip">提示：已打过的打印单会再次打印，请谨慎使用</p>
          </div>
          <div class="footer">
            <div class="div let" @click="pickingVisible = false">取消</div>
            <van-button class="div rig" type="default" :loading="loading" @click="doPickingFun('all')">确定打印</van-button>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script> 
import http from "@/utils/axios";
export default {
  data() {
    return {
      pickingVisible: false,
      form:{
        "branchRemarkType": "",
        "endTime": "",
        "orderBy": "",
        "orderStatusQuery": "",
        "orderTypeQuery": "",
        "searchKey": "",
        "startTime": "",
        "printStatus":0,
        "isPrintAll": "",
        "subOrderIdList": []
      },
      rform:{
        disablePringCount: 0,
        enablePrintCount: 0  
      },
      loading: false
    }
  },
  methods: { 
    init(row={}){
      for (const key in row) {
        this.form[key] = row[key]
      }
      http({
        url: 'order/appOrder/bees/searchDeliveryPrintCount',
        method: "POST",
        parmes: this.form
      }).then(rps => {
        this.rform = rps.data
        this.pickingVisible = true
      }).catch(rps=>{
          
      });
    },
    doPickingFun(row){
      this.loading = true
      let parm = row === 'all' ? {'orderQueryParam':this.form,'isPrintAll':this.form.isPrintAll,'subOrderIdList':this.form.subOrderIdList } : row
      http({
        url: 'order/admin/pickingList/print',
        method: "POST",
        parmes: parm
      }).then(rps => {
        if (rps.code === 200 && rps.data) {
          this.$toast(rps.message || '成功');
          this.loading = false
          this.$emit('callbackFun', parm.subOrderIdList[0])
          this.pickingVisible = false
        }
      }).catch(rps=>{
         this.pickingVisible = false
      });
    },   
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .block {
    width: 600px;
    background: #FFFFFF;
    border-radius: 10px;
    .title{
      font-size: 28px;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin-top: 25px;
      margin-bottom: 19px;
    }
    .footer{
      font-size: 28px;
      height: 100px;
      display: flex;
      border:1PX solid #D8D8D8;
       border-bottom-left-radius: 10px;
       border-bottom-right-radius: 10px;
      .div{
        height: 100px;
        line-height: 100px;
        text-align: center;
        width: 50%;
      }
      .let{
        border-right:1PX solid #D8D8D8;
        color:#333333;
      }
      .rig{
        color:#F8A651;
      }
    }
  }
}
.pck-div{
  font-size: 24px;
  color: #999999;
  text-align: left;
  padding-left: 40px;
  p{
  margin-bottom: 18px;
  span{
    font-size: 36px;
    font-weight: 500;
    color: #ED3939;
  }
  }
  .tip{
    color: #F8A651;
  }
  
}
</style>
